export function formatWebinarTime(startUtc, tz) {
  const d = new Date(startUtc);
  const now = new Date();
  const day = new Date(d.getFullYear(), d.getMonth(), d.getDate());
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const diffDays = Math.round((day - today) / 86400000);
  let dayLabel;
  if (diffDays === 0) dayLabel = "Today";
  else if (diffDays === 1) dayLabel = "Tomorrow";
  else
    dayLabel = new Intl.DateTimeFormat("en-US", { weekday: "short", month: "short", day: "numeric", timeZone: tz }).format(d);
  const time = new Intl.DateTimeFormat("en-US", {
    hour: "numeric", minute: "2-digit", hour12: true, timeZone: tz,
  }).format(d);
  const tzShort = new Intl.DateTimeFormat("en-US", { timeZoneName: "short", timeZone: tz })
    .formatToParts(d).find((p) => p.type === "timeZoneName")?.value || "";
  return { dayLabel, time, tzShort };
}

export function fmtMoney(symbol, amount) {
  return `${symbol}${Number(amount).toLocaleString()}`;
}

export function fmtDate(iso) {
  if (!iso) return "";
  return new Intl.DateTimeFormat("en-US", { year: "numeric", month: "short", day: "numeric" }).format(new Date(iso));
}
